import React, { useEffect, useState } from "react";
import Button from "../Button/Button";
import { InfiosButtonAuthorable } from "./ButtonAuthorable.style";
import { ErrorBoundary } from "react-error-boundary";
import { urlHasParam } from "../../utils/js/params";

const ButtonAuthorable = (props) => {
  const { text, id, noIcon, buttonVariation, disabled, alignment, animated, inverted, onClick, blank, icon, className, fullWidthOnMobileAndTablet, floating, isInEditor, floatingAboveChat } = props;

  function handleClick() {
    window.open(onClick, blank ? '_blank' : '_self');
  }

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const stage = document.querySelector(".stage");
    if (!stage) {
      setIsVisible(true);
      return;
    }

    const handleScroll = () => {
      const stageBottom = stage.getBoundingClientRect().bottom;
      setIsVisible(window.scrollY > stageBottom);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  const floatingClasses = !isInEditor && floating ? 'is_floating' : '';
  const floatingAboveChatClasses = !isInEditor && floatingAboveChat ? 'is_floatingAboveChat' : '';

  return (
    <InfiosButtonAuthorable alignment={alignment}>
      <Button
        text={text || "Infios Button"}
        className={`${className ? className : ""} ${floatingClasses} ${floatingAboveChatClasses} ${isVisible ? 'visible' : 'hidden'}`}
        noIcon={noIcon}
        icon={icon}
            id={id}
        secondary={buttonVariation === 'secondary'}
        tertiary={buttonVariation === 'tertiary'}
        partner={buttonVariation === 'partner'}
				blue={buttonVariation === 'blue'}
        green={buttonVariation === 'green'}
        greenlight={buttonVariation === 'greenlight'}
        white={buttonVariation === 'white'}
        disabled={disabled}
        animated={true}
        animatedVertically={icon === 'handshake'}
        inverted={inverted}
        floating={floating}
        floatingAboveChat={floatingAboveChat}
        isInEditor={isInEditor}
        onClick={handleClick}
        fullWidthOnMobileAndTablet={fullWidthOnMobileAndTablet}
      />
    </InfiosButtonAuthorable>
  );
}

const ButtonAuthorableHandleErrors = (props) => {
  return (
    <ErrorBoundary fallback={props.isInEditor || urlHasParam('wcmmode=disabled') ? <div style={{ minHeight: '50px', display: 'flex', alignItems: 'center', backgroundColor: '#ffe1db' }}><p>The button authorable component is currently experiencing errors. Please try again later.</p></div> : <div></div>}>
      <ButtonAuthorable {...props} />
    </ErrorBoundary>
  )
}

export default ButtonAuthorableHandleErrors;
